// 🔇 **GLOBAL CONSOLE OVERRIDE**: Disable all console outputs in production
// This removes all console.log, console.warn, console.error, and console.info calls
if (typeof window !== 'undefined') {
  const noop = () => {};
  console.log = noop;
  console.warn = noop;
  console.error = noop;
  console.info = noop;
  console.debug = noop;
  console.trace = noop;
  console.group = noop;
  console.groupCollapsed = noop;
  console.groupEnd = noop;
  console.table = noop;
  console.time = noop;
  console.timeEnd = noop;
  console.timeLog = noop;
  console.count = noop;
  console.countReset = noop;
  console.clear = noop;
  console.dir = noop;
  console.dirxml = noop;
  console.assert = noop;
}

// Import polyfills first
import '../src/polyfills.js';

// Explicitly ensure Buffer is available globally
import { Buffer } from 'buffer';

// Make sure Buffer is globally available before any other imports
if (typeof window !== 'undefined') {
  window.Buffer = Buffer;
  window.global = window;
  // Assign to any potential naming variations that might be causing issues
  (window as any).dist = { from: Buffer.from.bind(Buffer) };
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './styles/widget-overrides.css'; // Custom widget styles with transparency

// Import services but don't initialize them automatically
// Services will be initialized on-demand when components need them
import serviceInitializer from './services/serviceInitializer';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
